import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from '@services/core/entity.service';
import { EditOfficeComponent } from './editOffice/edit_office.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-office',
    templateUrl: './office.component.html',
    styleUrls: ["./office.component.css"],
    imports: [CommonModule, NgbTooltipModule, PanelComponent, EditOfficeComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true,
})
export class OfficeComponent implements OnInit {
    protected offices
    protected office
    private officesTemp
    protected showEditOffice = false
    private entityService = inject(EntityService)
    private destroyRef = inject(DestroyRef)


    ngOnInit(): void {
        this.getOffices()
    }

    getOffices() {
        this.office = null
        this.showEditOffice = false
        this.entityService.getOffices().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.offices = res
            this.officesTemp = res
        })
    }

    filterOffices(valor: string) {
        if (valor.length > 0) {
            this.offices = this.officesTemp.filter((office: any) =>
                office.name.toLowerCase().includes(valor.toLowerCase()) ||
                office.acronym.toLowerCase().includes(valor)
            );
        } else {
            this.offices = this.officesTemp
        }

    }

    toggleOffice(office: any) {
        office.enabled = !office.enabled
        this.entityService.updateOffice(office).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }

    addOffice() {
        this.office = null
        this.showEditOffice = true
    }

    setEditOffice(office: any) {
        this.office = office
    }

    moveUp(i: number) {
        if (i === 0) return
        const item = this.offices[i]
        this.offices[i] = this.offices[i - 1]
        this.offices[i - 1] = item
        this.entityService.updateOffices(this.offices).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }

    moveDown(i: number) {
        if (i === this.offices.length - 1) return
        const item = this.offices[i]
        this.offices[i] = this.offices[i + 1]
        this.offices[i + 1] = item
        this.entityService.updateOffices(this.offices).pipe(takeUntilDestroyed(this.destroyRef)).subscribe()
    }
}
